// extracted by mini-css-extract-plugin
export default {"mobileEditorXToolbar":"KjZ0s","button":"tqJZH"};